import { render, staticRenderFns } from "./PatientAntecedents.vue?vue&type=template&id=5dbd3287&"
import script from "./PatientAntecedents.vue?vue&type=script&lang=js&"
export * from "./PatientAntecedents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports